/**
 * Potter's Vineyard header — old prod account control parity.
 *
 * Old prod (live main.js getUserOptions + index.css #user-login-link):
 *   - logged out: Material Symbols Outlined "person" glyph, 22px, in the header
 *     action color — not the base white-circle person icon.
 *   - dropdown rows: a 32px rounded tile before the label — the person glyph
 *     on #EBEDF0 for "Login", the customer's initial on the brand green for the
 *     logged-in name row.
 *
 * The base Header re-renders the button + menu on ws-toggle / login / logout
 * for Commerce7 tenants, so a one-time swap would be undone on the next open —
 * a MutationObserver re-applies it after every re-render.
 */
import Header from "../../../components/base/Header.js";

// Material Symbols Outlined "person" (FILL 0, wght 400, opsz 24), Apache-2.0.
const PERSON_ICON = `<svg class="ws-pv-person" xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 -960 960 960" fill="currentColor" aria-hidden="true"><path d="M480-480q-66 0-113-47t-47-113q0-66 47-113t113-47q66 0 113 47t47 113q0 66-47 113t-113 47ZM160-160v-112q0-34 17.5-62.5T224-378q62-31 126-46.5T480-440q66 0 130 15.5T736-378q29 15 46.5 43.5T800-272v112H160Zm80-80h480v-32q0-11-5.5-20T700-306q-54-27-109-40.5T480-360q-56 0-111 13.5T260-306q-9 5-14.5 14t-5.5 20v32Zm240-320q33 0 56.5-23.5T560-640q0-33-23.5-56.5T480-720q-33 0-56.5 23.5T400-640q0 33 23.5 56.5T480-560Zm0-80Zm0 400Z"/></svg>`;

function iconTile(extraClass, content) {
  const tile = document.createElement("span");
  tile.className = `ws-pv-login-icon ${extraClass}`.trim();
  tile.setAttribute("aria-hidden", "true");
  tile.innerHTML = content;
  return tile;
}

export default class PottersHeader extends Header {
  _buildLogin() {
    const wrap = super._buildLogin();
    const btn = wrap.querySelector(".ws-btn-login");
    const menu = wrap.querySelector(".ws-login-menu");

    const apply = () => {
      // Swap only the generic person icon; the logged-in initial avatar stays.
      const svg = btn.querySelector(":scope > svg");
      if (svg && !svg.classList.contains("ws-pv-person")) btn.innerHTML = PERSON_ICON;

      // Old prod dropdown had Login only — drop the base Register link (set
      // when account_register_url is configured) from the header menu.
      menu.querySelectorAll("a.ws-login-item").forEach((link) => {
        if (link.textContent.trim() === "Register") link.remove();
      });

      menu.querySelectorAll("button.ws-login-item").forEach((item) => {
        if (item.querySelector(".ws-pv-login-icon") || item.textContent.trim() !== "Login") return;
        item.prepend(iconTile("", PERSON_ICON));
      });

      const name = menu.querySelector(".ws-login-name");
      if (name && !name.querySelector(".ws-pv-login-icon")) {
        const initial = name.textContent.trim().charAt(0).toUpperCase();
        name.prepend(iconTile("ws-pv-login-icon--user", initial));
      }
    };

    apply();
    new MutationObserver(apply).observe(wrap, { childList: true, subtree: true });
    return wrap;
  }
}
